import { Component } from 'opus-angular-seed-core';


@Component({
    bindings: {
        list: '=',
        loading: '='
    },
    template: `
            <div class="block08" ng-class="{'skeleton': vm.loading }">
                <div class="heading01">
                    <h2>{{ 'report.10 most searched keywords in learning catalogue' | translate }}</h2>
                </div>
                <table class="data03">
                    <thead>
                    <tr>
                        <th>{{ 'report.Keyword' | translate }}</th>
                        <th>{{ 'report.No of searches' | translate }}</th>
                        <th>{{ 'report.Trend' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- Skeleton Loader -->
                        <tr ng-if="vm.loading" ng-repeat="n in [].constructor(10) track by $index">
                            <td><div class="skeleton-cell"></div></td>
                            <td><div class="skeleton-cell"></div></td>
                            <td><div class="skeleton-cell"></div></td>
                        </tr>

                        <tr ng-if="!vm.loading" ng-repeat="keyword in vm.list.items">
                            <td>{{ keyword.keyword }}</td>
                            <td>{{ keyword.count }}</td>
                            <td><span class="trend"
                                ng-class="{'up': keyword.trend === 'up', 'down': keyword.trend === 'down'}"
                            >{{ keyword.diff }}</span></td>
                        </tr>
                        <tr ng-if="!vm.list.items.length">
                            <td colspan="3" style="text-align: center;">{{ 'search.No results' | translate }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/reports/overview/learningcatalogue/index.js